const styles = ({ palette, mixins, shadows }) => ({
});

export default styles
